import '../sass/person-profile.scss';

import { openModal } from '../../../../assets/src/js/common/modals';

(() => {
    const $templateParts = document.querySelectorAll('.person-profile');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $searchDropdown = $templatePart.querySelector('.person-profile-search-dropdown__dropdown');
        const $links = $templatePart.querySelectorAll('.person-profile-nav__link');
        const $panels = $templatePart.querySelectorAll('.person-profile-panel');
        const $select = $templatePart.querySelector('.person-profile-statistics__select');
        const $statisticsTables = $templatePart.querySelectorAll('.person-profile-statistics__table');
        const $statisticsListItems = $templatePart.querySelectorAll('.person-profile-statistics__list-item');
        const $videoModalBtns = $templatePart.querySelectorAll('.person-profile-video-modal-btn');
        const $videoModal = $templatePart.querySelector('.person-profile-video-modal');
        const $videoPlayer = $templatePart.querySelector('.person-profile-video-modal__video-player');

        const initSearchDropdown = () => {
            if (!$searchDropdown) return;

            new Details($searchDropdown);
        };

        const initLinks = () => {
            if (!$links || !$panels) return;

            $links.forEach($link => {
                $link.addEventListener('click', e => {
                    e.preventDefault();
                    
                    const { panel } = $link.dataset;

                    const $panels = document.querySelectorAll(`.person-profile-panel`);

                    $links.forEach($link => {
                        if ($link.dataset.panel === panel) {
                            $link.classList.add('btn--solid', 'btn--disabled');
                            $link.classList.remove('btn--outline');
                        } else {
                            $link.classList.remove('btn--solid', 'btn--disabled');
                            $link.classList.add('btn--outline');
                        }
                    });

                    $panels.forEach($panel => {
                        if ($panel.classList.contains(`person-profile-panel--${panel}`)) {
                            $panel.classList.add('person-profile-panel--show');
                        } else {
                            $panel.classList.remove('person-profile-panel--show');
                        }
                    });

                    history.replaceState(null, null, $link.href);
                });
            });
        };

        const initStatisticsSelect = () => {
            if (!$select) return;

            $select.addEventListener('change', e => {
                e.preventDefault();

                const { value } = e.target;

                $statisticsTables.forEach($table => {
                    if ($table.classList.contains(`person-profile-statistics__table--${value}`)) {
                        $table.classList.remove('person-profile-statistics__table--hide');
                    } else {
                        $table.classList.add('person-profile-statistics__table--hide');
                    }
                });

                $statisticsListItems.forEach($item => {
                    if ($item.classList.contains(`person-profile-statistics__list-item--${value}`)) {
                        $item.classList.remove('person-profile-statistics__list-item--hide');
                    } else {
                        $item.classList.add('person-profile-statistics__list-item--hide');
                    }
                })
            });
        };

        const initModals = () => {
            if (!$videoModal) return;

            if ($videoModalBtns) {
                $videoModalBtns.forEach($btn => {
                    const { vimeoVideoId } = $btn.dataset;

                    $btn.addEventListener('click', () => {
                        let videoPlayer;

                        if ($videoPlayer) {
                            $videoPlayer.innerHTML = `<iframe src="https://player.vimeo.com/video/${vimeoVideoId}?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media&controls=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
                            videoPlayer = new Plyr($videoPlayer);
                            videoPlayer.play();
                        }

                        $videoModal.addEventListener('modalafterclose', () => {
                            videoPlayer?.stop();
                        });

                        openModal($videoModal);
                    });
                });
            }
        };

        initSearchDropdown();
        initLinks();
        initStatisticsSelect();
        initModals();
    });
})();
